import { diContainer } from "@/inversify.config";
import { SalvarAvaliacaoMinhasEmpresasParams } from "./ports/SalvarAvaliacaoCSATMinhasEmpresasGateway";
import { AbstractCSATGatewayHandler } from "./handlers/AbstractCSATGatewayHandler";
import { CSATMinhasEmpresasGatewayHandler } from "./handlers/MinhasEmpresasGatewayHandler";

export class CSATHandlerFactory {
  static handler() {
    const handler = diContainer.get<
      AbstractCSATGatewayHandler<SalvarAvaliacaoMinhasEmpresasParams>
    >(CSATMinhasEmpresasGatewayHandler);

    return handler;
  }
}
